import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { v4 as uuid } from "uuid";
import Link from "@mui/material/Link";
import { useSelector, useDispatch } from "react-redux";
import { goToPage } from "../redux/pageSlice";

function extractLabs(data) {
  try {
    const labs = JSON.parse(data[data.length - 1]);
    const lenDates = Object.keys(labs["date"]).length;
    var labsArr = [];
    let rowNames = Object.keys(labs);
    for (let i = 0; i < rowNames.length; i++) {
      let name = rowNames[i];
      if (name !== "date") {
        let id = uuid();
        labsArr.push({ name, id });
      }
    }
    //populating lab values in the array
    for (var lab in labs) {
      if (lab !== "date") {
        //for each lab name
        const vals = labs[lab];
        for (var key in vals) {
          //for each value in each lab object
          let val = vals[key];
          let date = labs["date"][key];
          let pointer = labsArr.find(({ name }) => name == lab);
          pointer[date] = val;
        }
      }
    }
    labsArr.push(labs["date"]);
    return labsArr;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export default function Lab({ data }) {
  const rows = extractLabs(data);
  const dispatch = useDispatch();

  if (rows === null) {
    return (
      <>
        <p align="center">No values could be extracted; see PDF for more.</p>
      </>
    );
  }

  const handleClick = (value) => () => {
    console.log(value);
    dispatch(goToPage(value));
  };

  const headingsKeys = Object.keys(rows[rows.length - 1]);
  const headings = rows[rows.length - 1]; //dates
  const dates = Object.values(headings);
  return (
    <>
      <TableContainer component={Paper} sx={{ width: "100%", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}>
        <Table
          sx={{ maxWidth: "100%", width: "100%" }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "30%" }}>Lab Name</TableCell>
              {headingsKeys.map((h) => {
                return <TableCell>{headings[h]}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow>
                  <TableCell style={{ width: "30%" }}>{row.name}</TableCell>
                  {dates.map((h) => {
                    let value = row[h];
                    if (value !== undefined) {
                      let position = value.search(":"); //searching for position of page
                      let page = null;
                      if (position !== -1) {
                        // if position found
                        page = value.slice(position + 1);
                        value = value.slice(0, position);
                      }
                      return (
                        <TableCell>
                          <Link
                            style={{ cursor: "pointer" }}
                            onClick={handleClick(page)}
                          >
                            {value}
                          </Link>
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

